import React, { useState, createRef, useEffect } from "react";
import * as clipboard from "clipboard-polyfill"
import styled from "styled-components";

const Input = styled.input`
  background: var(--field);
  max-width: 1000px;
  width: 90%;
  line-height: 1.15;
  font-size: 2.5rem;
  border-radius: 6px;
  text-align: center;
  padding: 0.5rem 0.25rem;
  border: none;
  margin: 1.5rem 0;
  line-height: 1.75;
`;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--background);
`;

const Button = styled.button`
  width: 30%;
  max-width: 250px;
  background: ${props => (props.copied ? "var(--info)" : "var(--field)")};
  color: ${props => (props.copied ? "white" : "default")};
  border: none;
  border-radius: 6px;
  font-size: 1.5rem;
  padding: 0.5rem;
  font-variant-caps: all-small-caps;
  transition: all 0.2s ease;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
  &:hover {
    transform: translateY(-2px);
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.4);
  }
  &:active {
    transform: translateY(2px);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
  }
`;

const Title = styled.h1`
  font-size: 6rem;
  color: white;
  text-align: center;
  margin: 0;
  line-height: 1;
  @media (max-width: 600px) {
    font-size: 4rem;
  }
`;

const App = () => {
  const inputRef = createRef();
  const [text, setText] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const onTextChange = e => {
    setText(e.target.value.split(" ").join("👏"));
  };

  const onCopyClick = () => {
    clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <Container>
      <Title>CLAP TEXT GENERATOR</Title>
      <Input
        ref={inputRef}
        placeholder="👏"
        type="text"
        value={text}
        onChange={onTextChange}
      />
      <Button copied={copied} onClick={onCopyClick}>
        COP{copied ? "IED" : "Y"}
      </Button>
    </Container>
  );
};

export default App;
